// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"ClusterLayout_menuItem__3K0zT"};